module.exports = __webpack_public_path__ + "static/media/kszabo.4ce0a31f.jpg";